import {ColorsType} from '../../../../utils/theming';
import {SelectedColor, Size} from './SegmentedButton.types.web';

export const getContainerStyle = (colors: ColorsType, size: Size) => {
  return {
    backgroundColor: colors.neutral300,
    padding: size === 'medium' ? '8px' : '2px',
    minHeight: size === 'medium' ? '64px' : '36px',
  };
};

export const getSliderStyle = (
  colors: ColorsType,
  size: Size,
  selectedColor: SelectedColor,
  itemsLength: number,
  sliderTranslateX: any,
  sliderOpacity: any,
) => {
  return {
    backgroundColor:
      selectedColor === 'purple' ? colors.primary700 : colors.neutral100,
    width:
      size === 'medium'
        ? `calc(${100 / itemsLength}% - 6px)`
        : itemsLength !== 3
        ? `calc(${100 / itemsLength}% - 2px)`
        : `calc(${100 / itemsLength}%  - 1px)`,
    transform: `translateX(${sliderTranslateX}px)`,
    opacity: sliderOpacity,
    height: size === 'medium' ? 'calc(100% - 16px)' : 'calc(100% - 4px)',
  };
};

export const getItemStyle = (itemsLength: number, size: Size) => {
  return {
    width: `${100 / itemsLength}%`,
    padding: size === 'medium' ? '10px 22px' : '8px 16px',
  };
};
